<style>
#addMeasuringSeriesModal .v--modal-box.v--modal {
  min-width: 380px !important;
  min-height: 540px !important;
}
#addMeasuringSeriesModal .modal__content {
  overflow-y: hidden !important;
}
#addMeasuringSeriesModal .v-select__slot,
#addMeasuringSeriesModal .v-input__slot,
#addMeasuringSeriesModal .v-input__slot label,
#addMeasuringSeriesModal .v-select__slot label {
  font-size: 12px !important;
}
#addMeasuringSeriesModal .menuable__content__active {
  max-height: 200px !important;
}
</style>

<template>
  <Modal
    modalName="addMeasuringSeriesModal"
    title="Dodanie serii pomiarowej"
    :module="module"
    :buttons="['save']"
    @opened="getMeasures(pointID)"
    @closed="closed"
    @saved="sendProps"
  >
    <v-container>
      <v-layout
        row
        wrap
      >
        <p class="font--primary">W celu dodania nowej serii pomiarowej wprowadź informację do każdego pola, a następnie naciśnij przycisk u dołu okna.</p>
        <v-flex xs5>
          <v-text-field
            label="Nazwa pomiaru"
            v-model="measurementName"
          ></v-text-field>
        </v-flex>
        <v-spacer />
        <v-flex
          xs5
          id="modalSelect__series"
        >
          <v-select
            :items="seriesTypes"
            v-model="sType"
            attach="#modalSelect__series .v-input__slot"
            label="Typ serii pomiarowej"
            :disabled="!measurementName"
            @change="assignMeasuresList"
          ></v-select>
        </v-flex>

        <v-flex
          xs5
          id="modalSelect__symbol"
        >
          <v-combobox
            :items="measuringSymbol"
            v-model="symbol"
            attach="#modalSelect__symbol .v-input__slot"
            label="Symbol serii pomiarowej"
            :disabled="!sType"
          ></v-combobox>
        </v-flex>
        <v-spacer />
        <v-flex
          xs5
          id="modalSelect__parameter"
        >
          <v-select
            :items="measuringParameter"
            v-model="parameter"
            attach="#modalSelect__parameter .v-input__slot"
            label="Parametr"
            :disabled="!symbol"
            @change="assignParameter"
          ></v-select>
        </v-flex>
        <v-flex
          xs5
          id="modalSelect__unit"
        >
          <v-select
            :items="measuringUnit"
            v-model="mUnit"
            attach="#modalSelect__unit .v-input__slot"
            label="Jednostka pomiarowa"
            :disabled="!parameter"
          ></v-select>
        </v-flex>
      </v-layout>
    </v-container>
  </Modal>
</template>

<script>
import Modal from "../../../shared/Modal";

export default {
  components: {
    Modal
  },
  props: {
    pointID: Number
  },
  data: () => ({
    measurementName: undefined,
    module: "scada",
    sType: undefined,
    mUnit: undefined,
    symbol: undefined,
    parameter: undefined,
    seriesTypes: ["Dane bieżące", "Dane archiwalne", "Alarmy"],
    measuringSymbol: undefined,
    measuringSymbols: undefined,
    measuringUnit: [
      "[bar]",
      "[MPa]",
      "[m3/h]",
      "[m3/doba]",
      "[°C]",
      "[V]",
      "[cm]",
      "[m3]",
      "Nie dotyczy"
    ],
    measuringParameter: ["Alarm", "Ciśnienie", "Przepływ", "Inne"],
    visible: true,
    editedIndex: undefined
  }),
  methods: {
    closed() {
      this.measurementName = undefined;
      this.sType = undefined;
      this.mUnit = undefined;
      this.symbol = undefined;
      this.parameter = undefined;
      this.editedIndex = undefined;
    },
    sendProps() {
      if(
        !this.measurementName ||
        !this.sType ||
        !this.mUnit ||
        !this.symbol ||
        !this.parameter
      ) {
        this.$root.$emit(
          "showSnackbar",
          "red",
          "Błąd - wypełnij wszystkie, dostępne pola"
        );
        return;
      }
      this.$root.$emit("sendMeasuringDetails", [
        {
          name: this.measurementName,
          measure_type: this.sType,
          unit: this.mUnit,
          symbol: this.symbol,
          parameter: this.parameter,
          visible: this.visible
        },
        this.editedIndex
      ]);
      this.closed();
      this.$modal.hide("addMeasuringSeriesModal");
    },
    getMeasures(oid) {
      return this.$store.dispatch("getMeasuresList", oid).then(response => {
        if(response) {
          this.measuringSymbols = response;
        } else {
          this.$root.$emit(
            "showSnackbar",
            "red",
            "Podczas dodawania punktu pomiarowego wystąpił błąd"
          );
        }
      });
    },
    assignMeasuresList(data) {
      if(data == "Dane archiwalne") {
        this.measuringSymbol = this.measuringSymbols.archive_measures;
      } else if(data == "Alarmy") {
        this.measuringSymbol = this.measuringSymbols.current_measures.filter(
          measure => {
            return measure.startsWith("Alarm");
          }
        );
      } else {
        this.measuringSymbol = this.measuringSymbols.current_measures;
      }
    },
    assignParameter(data) {
      if(data == "Alarm") {
        this.mUnit = "Nie dotyczy";
      }
    },
    loadParams(data) {
      this.measurementName = data[0].name;
      this.sType = data[0].measure_type;
      this.symbol = data[0].symbol;
      this.parameter = data[0].parameter;
      this.mUnit = data[0].unit;
      this.editedIndex = data[1];
      this.getMeasures(this.pointID).then(() => {
        this.assignMeasuresList(data[0].measure_type);
      });
    }
  },
  mounted() {
    const self = this;
    this.$root.$on("editSeries", self.loadParams);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/scada/modals/AddMeasuringSeries.vue